import { IAddformGeocodeResponse } from '../../../repositories/monolith-python/v2/geocode';
import { TGetGeoByAddressData } from '../types';
import { mapAddress } from './mapAddress';
import { mapCoordinates } from './mapCoordinates';
import { mapHighway } from './mapHighway';
import { mapUnderground } from './mapUnderground';

export const mapResponse200 = (response: IAddformGeocodeResponse): TGetGeoByAddressData => {
  const { coordinates, locationPath, geoId, geoType, text } = response.data;

  const undergroundsRaw = response.data.underground || [];
  const highwaysRaw = response.data.highways || [];

  return {
    coordinates: mapCoordinates(coordinates),
    undergrounds: undergroundsRaw.map(mapUnderground),
    highways: highwaysRaw.map(mapHighway),
    address: mapAddress({ locationPath, geoId, geoType }),
    userInput: text,
  };
};
